import autobg from 'autobg.macro';
import React, { useState, useEffect } from 'react';
import ReactDOM from 'react-dom';
import styled from 'styled-components/macro';

const Wrap = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100vw;
  height: 100vh;
  background-color: #ffffff;
`;

const Icon = styled.div`
  ${autobg('assets/img/error.png')}
`;

const store = {
  setState: () => {}
};

const modal = {
  open: type => {
    store.setState({ type, open: true });
  }
};

const ErrorModal = () => {
  const [state, setState] = useState({
    open: false,
    type: ''
  });

  useEffect(() => {
    store.setState = setState;
  }, []);

  return (
    state.open && (
      <Wrap>
        <Icon />
      </Wrap>
    )
  );
};

const $root = document.createElement('div');
$root.style.cssText = `
  position: fixed;
  left: 0;
  top: 0;
  z-index: 99;
`;

document.body.appendChild($root);

ReactDOM.render(<ErrorModal />, $root);

export default modal;
